import { setPledgePaySurface } from './pledge-pay-surface';
import { bindPledgePayMemberDocumentHandlers, bootstrapMemberPledgePayPageConfig } from './pledge-pay-member';
import './pledge-pay-utils';
import './pledge-pay-member-context';
import './pledge-pay-open-credit-context';
import { hasPledgePayConfig } from './pledge-pay-config';
import './pledge-pay-amount';
import { refreshManagerPledgeModalOpenPaymentSection } from './pledge-pay-balance';
import './pledge-pay-surcharge';
import './pledge-pay-method';
import './pledge-pay-payload';
import './pledge-pay-bill-submit';
import './pledge-pay-table';
import './pledge-pay-recurring';
import './pledge-pay-modal';

export function initPledgePayPage() {
    bindPledgePayMemberDocumentHandlers();

    const $pledgePayBody = $('#pledge_pay_body');
    if (!$pledgePayBody.length) {
        return;
    }

    const surface = $pledgePayBody.attr('data-pledge-pay-surface');
    if (surface) {
        setPledgePaySurface(surface);
    }

    if (document.getElementById('member-pledge-pay-page-config')) {
        bootstrapMemberPledgePayPageConfig($pledgePayBody);
        if (hasPledgePayConfig()) {
            refreshManagerPledgeModalOpenPaymentSection($pledgePayBody);
        }
    }

    $pledgePayBody.find('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
    });
}
